/** Logical world rectangle and the CSS regions around it. Change layout here. */
import { VIEW_H, VIEW_W } from '../engine/constants'
export interface Rect {
  x: number
  y: number
  w: number
  h: number
}
const HEADER_H = 14.4
export const VIEW: Rect = { x: 30, y: 40, w: VIEW_W - 30, h: VIEW_H - 52 }
/** Set on the chrome root so CSS and Canvas picking reserve identical regions. */
export const CHROME_STYLE = [
  `--header-height:${(HEADER_H / VIEW_H) * 100}%`,
  `--view-top:${(VIEW.y / VIEW_H) * 100}%`,
  `--view-left:${(VIEW.x / VIEW_W) * 100}%`,
  `--footer-height:${((VIEW_H - VIEW.y - VIEW.h) / VIEW_H) * 100}%`,
].join(';')
